export const stockResearchNotesExpandCompConfig = {
  content: [
    {
      comp: "NewAnnotations",
      valuePath: "annotations.tags.[annoTagType].data",
      label: "Annotations",
    },
  ],
};
